var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 405.99 31.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #03477b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.69,7.4h3.78v14.71c0,1.96-.39,3.65-1.16,5.07-.77,1.42-1.85,2.51-3.23,3.28-1.38.76-2.99,1.14-4.82,1.14s-3.43-.38-4.82-1.14c-1.39-.76-2.48-1.85-3.26-3.28-.78-1.42-1.17-3.11-1.17-5.07V7.4h3.78v14.51c0,1.3.24,2.41.71,3.33s1.12,1.63,1.94,2.12,1.76.74,2.82.74,1.99-.25,2.81-.74,1.46-1.2,1.93-2.12c.47-.92.7-2.03.7-3.33V7.4Zm-6.89-1.01l-1.28-1.71L12.13,0l2.02,2.56-6.35,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.26,10.94l.25.04v20.18h-3.78V7.4h5.27l11.48,20.16-.23.05V7.4h3.76v23.76h-5.29l-11.47-20.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.65,7.4h14.4v3.38h-10.64v6.82h10.46v3.29h-10.46v6.88h10.64v3.38h-14.4V7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.41,10.78h-6.17v-3.38h16.15v3.38h-6.17v20.38h-3.8V10.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.62,7.4h14.4v3.38h-10.64v6.82h10.46v3.29h-10.46v6.88h10.64v3.38h-14.4V7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.11,7.4h3.87l8.96,23.76h-4.03l-1.96-5.44h-9.79l-1.98,5.44h-4.05l8.98-23.76Zm-1.73,14.96h7.34l-3.65-10.35h-.05l-3.64,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.48,7.4h3.8v20.38h9.13v3.38h-12.92V7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.66,7.4h3.87l8.96,23.76h-4.03l-1.96-5.44h-9.79l-1.98,5.44h-4.05l8.98-23.76Zm-1.73,14.96h7.34l-3.65-10.35h-.05l-3.64,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m200.34,7.4h3.87l8.96,23.76h-4.03l-1.96-5.44h-9.79l-1.98,5.44h-4.05l8.98-23.76Zm-1.73,14.96h7.34l-3.65-10.35h-.05l-3.64,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.35,31.16h-4.37l-8.62-23.76h4.27l6.55,19.06,6.57-19.06h4.27l-8.66,23.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m236,7.4h14.4v3.38h-10.64v6.82h10.46v3.29h-10.46v6.88h10.64v3.38h-14.4V7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.53,10.94l.25.04v20.18h-3.78V7.4h5.27l11.48,20.16-.23.05V7.4h3.76v23.76h-5.29l-11.47-20.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m284.67,10.78h-6.17v-3.38h16.15v3.38h-6.17v20.38h-3.8V10.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.39,7.4h3.78v14.71c0,1.96-.39,3.65-1.16,5.07-.77,1.42-1.85,2.51-3.23,3.28-1.38.76-2.99,1.14-4.82,1.14s-3.43-.38-4.82-1.14c-1.39-.76-2.48-1.85-3.26-3.28-.78-1.42-1.17-3.11-1.17-5.07V7.4h3.78v14.51c0,1.3.24,2.41.71,3.33s1.12,1.63,1.94,2.12,1.76.74,2.82.74,1.99-.25,2.81-.74,1.46-1.2,1.93-2.12c.47-.92.7-2.03.7-3.33V7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m320.4,7.4h8.73c1.31,0,2.49.27,3.56.82s1.9,1.34,2.53,2.38.94,2.31.94,3.8-.28,2.69-.85,3.65c-.56.96-1.24,1.68-2.03,2.16s-1.53.75-2.21.81l5.85,10.13h-4.27l-5.4-9.85h-3.06v9.85h-3.78V7.4Zm3.78,11.18h3.6c1.27,0,2.34-.32,3.2-.95.86-.64,1.3-1.67,1.3-3.11s-.43-2.48-1.28-3.1c-.85-.61-1.91-.92-3.19-.92h-3.64v8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346.41,7.4h3.87l8.96,23.76h-4.03l-1.96-5.44h-9.79l-1.98,5.44h-4.05l8.98-23.76Zm-1.73,14.96h7.34l-3.65-10.35h-.05l-3.64,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m370.71,7.4h6.07c2.53,0,4.62.51,6.26,1.52s2.87,2.42,3.67,4.2c.8,1.79,1.21,3.83,1.21,6.14s-.4,4.37-1.2,6.16c-.8,1.79-2.02,3.19-3.66,4.21s-3.74,1.53-6.28,1.53h-6.07V7.4Zm3.76,3.42v16.92h1.98c1.72,0,3.12-.36,4.22-1.09,1.1-.73,1.91-1.73,2.44-3,.53-1.27.8-2.72.81-4.36.01-1.63-.25-3.09-.77-4.37-.53-1.28-1.35-2.28-2.46-3.02-1.11-.73-2.52-1.1-4.24-1.1h-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m391.59,7.4h14.4v3.38h-10.64v6.82h10.46v3.29h-10.46v6.88h10.64v3.38h-14.4V7.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadline);
export default __webpack_public_path__ + "static/media/headline.1e1b4c02a215db962a2c155bde2f082c.svg";
export { ForwardRef as ReactComponent };